import { convertText } from '@/utils/langConvert';

export interface BasicInfoFixedLabels {
  trueSolarTime: string;
  birthSolar: string;
  eastWest: string;
  timeMarkers: string;
  pillarReferences: string;
}

function getLangKey(language: string): string {
  if (language === 'zh-HK') return 'zh-HK';
  if (language === 'zh-TW') return 'zh-TW';
  if (language.startsWith('zh')) return 'zh-CN';
  if (language.startsWith('ko')) return 'ko';
  if (language.startsWith('ja')) return 'ja';
  return 'en';
}

export function getBasicInfoFixedLabels(language: string): BasicInfoFixedLabels {
  const lang = getLangKey(language);
  const isZh = lang === 'zh-CN' || lang === 'zh-TW' || lang === 'zh-HK';
  return {
    trueSolarTime: isZh ? convertText('真太阳时', language) : 'True Solar',
    birthSolar: isZh ? convertText('出生阳历', language) : 'Solar',
    eastWest: lang === 'ko' ? '동서사명' : lang === 'ja' ? '東西四命' : isZh ? convertText('东西四命', language) : 'East/West',
    timeMarkers: isZh ? convertText('八字天时定位', language) : 'Bazi Time Markers',
    pillarReferences: isZh ? convertText('四柱辅助定位', language) : 'Pillar References',
  };
}
